"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTagPicker_unstable", {
    enumerable: true,
    get: function() {
        return renderTagPicker_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactaria = require("@fluentui/react-aria");
const _reactcombobox = require("@fluentui/react-combobox");
const _reactportal = require("@fluentui/react-portal");
const _TagPickerContext = require("../../contexts/TagPickerContext");
const _reactutilities = require("@fluentui/react-utilities");
const renderTagPicker_unstable = (state, contexts)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ _react.createElement(_TagPickerContext.TagPickerContextProvider, {
        value: contexts.picker
    }, /*#__PURE__*/ _react.createElement(_reactaria.ActiveDescendantContextProvider, {
        value: contexts.activeDescendant
    }, /*#__PURE__*/ _react.createElement(_reactcombobox.ListboxProvider, {
        value: contexts.listbox
    }, state.trigger, state.inline ? state.popover : /*#__PURE__*/ _react.createElement(_reactportal.Portal, {
        mountNode: state.mountNode
    }, state.popover))));
};
